import { useState } from 'react';
import { Link } from 'react-router';
import { ArrowLeft, Scroll, Crown, ChevronRight, Filter } from 'lucide-react';
import './my-collections.css';
import { Header } from '../../components';
import { ROUTES } from '../../routes';

const mockCollections = [
  {
    liga: 'Liga Amatista',
    color: '#6A0DAD',
    icon: '💎',
    temporadas: [
      {
        id: 1,
        fecha: '15 Abril 2026',
        tokens: [147, 3892, 7654, 12001, 19876],
        ganador: false,
      },
      {
        id: 2,
        fecha: '14 Abril 2026',
        tokens: [234, 5678],
        ganador: true,
        premio: '350.00€',
      },
      {
        id: 3,
        fecha: '13 Abril 2026',
        tokens: [1001, 2002, 3003, 4004],
        ganador: false,
      },
    ],
  },
  {
    liga: 'Liga Tanzanita',
    color: '#4B3F72',
    icon: '💎',
    temporadas: [
      {
        id: 1,
        fecha: '15 Abril 2026',
        tokens: [147, 3892, 7654, 12001, 19876],
        ganador: false,
      },
      {
        id: 2,
        fecha: '14 Abril 2026',
        tokens: [234, 5678],
        ganador: true,
        premio: '350.00€',
      },
      {
        id: 3,
        fecha: '13 Abril 2026',
        tokens: [1001, 2002, 3003, 4004],
        ganador: false,
      },
    ],
  },
];

const MisColecciones = () => {
  const [selectedLiga, setSelectedLiga] = useState<string | null>(null);
  const [filterGanadores, setFilterGanadores] = useState(false);

  const ligasToShow = selectedLiga
    ? mockCollections.filter((l) => l.liga === selectedLiga)
    : mockCollections;

  return (
    <div className="mc-container">
      <header className="mc-header">
        <div className="mc-header-inner">
          <div className="mc-header-top">
            <Link to={ROUTES.HOME} target="_top" className="mc-back">
              <ArrowLeft stroke="#9CA3AF" className="mc-icon-sm" />
              <span>Volver al inicio</span>
            </Link>

            <div className="mc-title-wrap">
              <Scroll stroke="#5025E1" className="mc-icon-lg" />
              <h1 className="mc-title">Mis Colecciones</h1>
            </div>
          </div>
        </div>
      </header>

      <div className="mc-content">
        <div className="mc-stats">
          <div className="mc-stat purple">
            <p className="mc-stat-label">Total de Tarjetas</p>
            <p className="mc-stat-value">
              {mockCollections.reduce(
                (total, liga) =>
                  total +
                  liga.temporadas.reduce(
                    (sum, temp) => sum + temp.tokens.length,
                    0,
                  ),
                0,
              )}
            </p>
          </div>

          <div className="mc-stat green">
            <p className="mc-stat-label">Temporadas Participadas</p>
            <p className="mc-stat-value">
              {mockCollections.reduce(
                (total, liga) => total + liga.temporadas.length,
                0,
              )}
            </p>
          </div>

          <div className="mc-stat cyan">
            <p className="mc-stat-label">Victorias</p>
            <p className="mc-stat-value">
              {mockCollections.reduce(
                (total, liga) =>
                  total + liga.temporadas.filter((t) => t.ganador).length,
                0,
              )}
            </p>
          </div>
        </div>

        <div className="mc-filters">
          <button
            onClick={() => setFilterGanadores(!filterGanadores)}
            className={`mc-filter ${filterGanadores ? 'active' : ''}`}
          >
            <Filter
              stroke={filterGanadores ? '#000011' : '#9CA3AF'}
              className="mc-icon-xs"
            />
            Solo Victorias
          </button>

          {selectedLiga && (
            <button onClick={() => setSelectedLiga(null)} className="mc-reset">
              Ver Todas las Ligas
            </button>
          )}
        </div>

        <div className="mc-ligas">
          {ligasToShow.map((liga) => (
            <div key={liga.liga} className="mc-liga">
              <div
                className="mc-liga-header"
                onClick={() =>
                  setSelectedLiga(selectedLiga === liga.liga ? null : liga.liga)
                }
              >
                <div
                  className="mc-liga-icon"
                  style={{ backgroundColor: liga.color }}
                >
                  <span className="mc-liga-emoji">{liga.icon}</span>
                </div>

                <h2 className="mc-liga-title">{liga.liga}</h2>

                <ChevronRight
                  stroke="#9CA3AF"
                  className={`mc-icon-md ${
                    selectedLiga === liga.liga ? 'rotate' : ''
                  }`}
                />

                <span className="mc-liga-count">
                  {liga.temporadas.length} temporada
                  {liga.temporadas.length !== 1 ? 's' : ''}
                </span>
              </div>

              <div className="mc-grid">
                {liga.temporadas
                  .filter((t) => !filterGanadores || t.ganador)
                  .map((temporada) => (
                    <div
                      key={`${liga.liga}-${temporada.id}`}
                      className={`mc-card ${
                        temporada.ganador ? 'winner' : 'normal'
                      }`}
                    >
                      {temporada.ganador && (
                        <div className="mc-badge">
                          <Crown stroke="#000011" className="mc-icon-xs" />
                          Victoria
                        </div>
                      )}

                      <div className="mc-card-header">
                        <p className="mc-card-sub">Temporada #{temporada.id}</p>
                        <p className="mc-card-date">{temporada.fecha}</p>

                        {temporada.ganador && temporada.premio && (
                          <p className="mc-prize">Premio: {temporada.premio}</p>
                        )}
                      </div>

                      <div>
                        <p className="mc-token-label">
                          Tokens Coleccionados ({temporada.tokens.length})
                        </p>

                        <div className="mc-tokens">
                          {temporada.tokens.map((token) => (
                            <div
                              key={token}
                              className="mc-token"
                              style={{
                                backgroundColor: `${liga.color}40`,
                                border: `2px solid ${liga.color}`,
                                color: '#ffffff',
                              }}
                            >
                              #{token}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>

        {mockCollections.length === 0 && (
          <div className="mc-empty">
            <Scroll stroke="#4B5563" className="mc-empty-icon" />
            <h3 className="mc-empty-title">Aún no tienes colecciones</h3>
            <p className="mc-empty-text">
              Participa en las ligas para empezar a coleccionar tokens únicos
            </p>
            <Link to={ROUTES.HOME} target="_top" className="mc-empty-btn">
              Explorar Ligas
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

const MyCollections = () => {
  return (
    <>
      <Header goBack={{ path: ROUTES.HOME }} title="Mis Colecciones" />

      <div className="mc-container building">
        <div className="mc-stats building">
          <div className="mc-stat purple">
            Estamos actualizando esta pestaña...
            <p>
              <b>Sentimos las molestias</b>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyCollections;
